export default [
    {
        path: 'cadastro-individual',
        component: () => import(
            '@/views/atencao-basica/cadastro-individual/Index'
        ),
        redirect: 'cadastro-individual/index',
        children: [
            {
                name: 'atencao-basica-cadastro-individual',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/cadastro-individual/List'
                ),
            },
            {
                name: 'atencao-basica-cadastro-individual-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/cadastro-individual/Form'
                )
            },
        ],
    },
]